import { useNavigate } from "react-router-dom";

import './atd-documento.scss';
import HeaderHora from "../../components/headerHora.tsx";
import { CountdownBar } from "../../components/CountdownBar.tsx";
import InternetStatus from "../../components/conexao.tsx";

export function AtdDocumentViewer() {
    const navigate = useNavigate();

    return (
        <div className="viewer-page">
            <HeaderHora/>
        
            <div className='status-face'>
                <CountdownBar/>
                <InternetStatus/>
            </div>

            <div className="viewer-content">
                <iframe
                title="ATD Document Viewer"
                src={`${JSON.parse(sessionStorage.getItem("dadosLinkAtual")).outNomeArquivo}`}
                />
            </div>

            <div className="viewer-footer">
                <button onClick={() => navigate("/document")}>
                CONTINUAR
                </button>
            </div>

        </div>
    );
}
